<template>
  <v-container class="container-view">
    <v-card elevation="6" style="border-radius: 0px">
      <v-card-title
        class="title-background font-futura-subtitle"
      >
        {{ $t("my-contracts") }}
      </v-card-title>
      <v-card-text>
        <div>
          <v-data-table
            :items="files"
            :headers="headers"
            class="font-humanist"
            hide-default-footer
            :no-data-text="$t('no-data')"
          >
            <template v-slot:item.fileName="{ item }">
              <v-icon
                :icon="
                  item.contentType == 'application/pdf'
                    ? mdiFilePdfBox
                    : mdiFileWordBox
                "
                size="x-large"
              ></v-icon>
              {{ item.fileName }}
            </template>

            <template v-slot:item.fileSize="{ item }">
              <span> {{ Math.floor(item.fileSize / 1024) }}Ko </span>
            </template>

            <template v-slot:item.uploadDate="{ item }">
              <span>
                {{ new Date(item.uploadDate).toLocaleDateString() }}
              </span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                :icon="mdiDownload"
                @click="downloadFile(item)"
                size="x-large"
              >
              </v-icon>
            </template>
            <template v-slot:item.size="{ item }">
              <span>
                {{ item.size }}
              </span>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mdiFilePdfBox, mdiFileWordBox, mdiDownload } from "@mdi/js";
import { mapState } from "vuex";

export default {
  name: "ContratView",
  data() {
    return {
      mdiFilePdfBox,
      mdiFileWordBox,
      mdiDownload,
      contracts: [
        {
          fichier: {
            type: "PDF",
            nom: "Mon contrat",
            path: "",
          },
          taille: "4MB",
          contributeur: "Justine",
          actions: "",
        },
      ],
      headers: [
        {
          title: this.$t("file"),
          key: "fileName",
          align: "start",
          sortable: false,
        },
        {
          title: this.$t("size"),
          key: "fileSize",
          align: "start",
          sortable: false,
        },
        {
          title: this.$t("uploaded-date"),
          key: "uploadDate",
          align: "start",
          sortable: false,
        },
        {
          title: this.$t("actions"),
          key: "actions",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      files: (state) => state.files.items,
    }),
  },
  methods: {
    downloadFile(item) {
      this.$store
        .dispatch("files/downloadFile", item.id)
        .then((response) => {
          const blob = new Blob([response.data], { type: item.fileType });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = item.fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$store.dispatch("showSnackbar", {
            message: this.$t("alert.error.file-download"),
            color: "error",
          });
        });
    },
  },
};
</script>
